import { TaskItem } from '@all-manager/design-system-v2';
import { OpenPendingItemWithSubTopic } from '../../../../types';
import { useOpenPendingItem } from './useOpenPendingItem';

type Props = {
  item: OpenPendingItemWithSubTopic;
};

export default function OpenPendingItem(props: Props) {
  const hook = useOpenPendingItem(props);

  return (
    <TaskItem
      task={props.item}
      subTopicHref={hook.targetUrl}
      onSubTopicClick={hook.handleSubTopicClick}
      onChange={hook.handleToggle}
      disabled={!hook.isAdmin}
    />
  );
}

export { OpenPendingItem };
